import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon, Text } from '@ui-kitten/components';

import { EventDetails } from '../../RTK/api/events/types';
import themeStyle, { globalSpacing } from '../../Theme/styles';
import Image from '../../Components/Image';
import { formatDistanceFromMeters } from '../../Helper';
import Button from '../../Components/Button';
import ListItem from '../../Components/ListItem';

const ReservationCardSmall = ({
  loading,
  store,
  onClose,
  onPress,
}: EventDetails & {
  loading?: boolean;
  onClose: () => void;
  onPress: () => void;
}) => {
  if (loading) return null;
  return (
    <Button onPress={onPress} plain>
      <View style={styles.wrapper}>
        <Image
          source={{ uri: store.partner_banner }}
          style={{ width: 100, aspectRatio: 1 / 1 }}
        />
        <View style={themeStyle.spacingLeftMedium}>
          <ListItem
            contentContainerStyle={themeStyle.spacingBottomSmall}
            rightIcon={{ name: 'close', onPress: onClose }}
            title={<Text category="h6">{store.name}</Text>}
          />
          <Text appearance="hint" style={themeStyle.spacingBottomSmall}>
            {formatDistanceFromMeters(store.distance)}{' '}
            {store.store_tags.join(' ● ')}
          </Text>
          <View style={themeStyle.alignItemsEnd}>
            <Button
              accessoryRight={(props) => (
                <Icon
                  {...props}
                  name="chevron-right"
                  style={[props.style, { marginHorizontal: 0 }]}
                />
              )}
              status="info"
              style={{ borderRadius: 5 }}
              size="small"
              onPress={onPress}
            >
              Reserve
            </Button>
          </View>
        </View>
      </View>
    </Button>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    ...themeStyle.shadow,
    ...themeStyle.pageBackground,
    ...themeStyle.flexDirectionRow,
  },
  closeContainer: {
    position: 'absolute',
    top: 0,
    // right: -10,
    // top: -10,
  },
});

export default React.memo(ReservationCardSmall);
